import React from 'react';

import { Text } from '@lightspeed/flame/Text';

import { createReactRenderer } from '../helpers/react-renderer';
import { datadogRum } from 'root/datadog/datadogRum';

import { StyledButton } from './SerializedRefundButton.style';
import { SerializedItem } from './types';

const SerializedRefundButton: React.FC<{
  quantityOut: string;
  arg: {
    itemId: number;
    saleId: number;
    transactionLineId: number;
    itemDescription: string;
    qout: number;
    serials: Array<{
      serial: string;
      colorName: string;
      sizeName: string;
      serializedId: number;
      isSelected: boolean;
      isRefunded: boolean;
    }>;
  };
}> = ({ quantityOut, arg }) => {
  const accountId = window.merchantos.session.getSystemCustomerID();
  const { serials, qout: initialQuantityOut, itemId } = arg;
  const remainingSerialsFromInitialSale = Number(quantityOut);

  // there's something selected on the current refund
  const registerWrapperHasChildNodes = document.getElementById('register_refund_transaction')
    ?.children.length;

  React.useEffect(() => {
    const registerRefundWrapperEl = document.getElementById('register_refund_transaction');
    const checkIsItemIdOnRefund = registerRefundWrapperEl?.querySelectorAll(
      `.sale-line-item-description-${itemId}`
    );

    // no serials were selected at time of initial sale
    // the full/remaining qty has been selected (happens automatically in this instance after clicking on the "Refund" button, but can be manually adjusted using the qty input)
    if (
      serials.length === 0 &&
      remainingSerialsFromInitialSale === 0 &&
      checkIsItemIdOnRefund?.length
    ) {
      const err = new Error('SERIALIZED REFUND BUTTON ISSUE LOG');
      datadogRum.addError(err, { merchantID: accountId });
    }
  }, [
    accountId,
    itemId,
    registerWrapperHasChildNodes,
    remainingSerialsFromInitialSale,
    serials.length,
  ]);

  const renderRefundContent = () => {
    const refundButton = (
      <StyledButton
        data-automation="refundButton"
        data-test="refund-button"
        onClick={() => window.merchantos.utils.startSerializedRefund(arg)}
        className="gui-def-button"
      >
        Refund
      </StyledButton>
    );

    const refundedText = <Text data-test="refunded-text">Refunded</Text>;

    const isSerialRefunded = (serial: SerializedItem) => serial.isRefunded;

    // All serials were selected at time of sale and not ALL are refunded
    if (serials.length === initialQuantityOut && !serials.every(isSerialRefunded)) {
      return refundButton;
    }

    // Some serials were not selected at time of sale
    if (serials.length !== initialQuantityOut && remainingSerialsFromInitialSale > 0) {
      return refundButton;
    }

    return refundedText;
  };

  return renderRefundContent();
};

const RenderedComponent = createReactRenderer({
  component: SerializedRefundButton,
  selector: '[data-react-root="SerializedRefundButton"]',
});

history.onChangeState(
  [{ pathname: '/register.php', form_name: undefined, view: undefined }],
  () => {
    RenderedComponent.mount();
  },
  () => {
    RenderedComponent.unmount();
  }
);

export default SerializedRefundButton;
